//Generated File 
export default class FieldType{
	static readonly BigText = `BigText`;
	static readonly Binary = `Binary`;
	static readonly Boolean = `Boolean`;
	static readonly Color = `Color`;
	static readonly Date = `Date`;
	static readonly DateAndTime = `DateAndTime`;
	static readonly Decimal = `Decimal`;
	static readonly Detail = `Detail`;
	static readonly Email = `Email`;
	static readonly EntityType = `EntityType`;
	static readonly Enum = `Enum`;
	static readonly FeatureID = `FeatureID`;
	static readonly FieldID = `FieldID`;
	static readonly Genericreference = `Genericreference`;
	static readonly ID = `ID`;
	static readonly Integer = `Integer`;
	static readonly LatLng = `LatLng`;
	static readonly Link = `Link`;
	static readonly Long = `Long`;
	static readonly LongToken = `LongToken`;
	static readonly Measures = `Measures`;
	static readonly Password = `Password`;
	static readonly PhoneNumber = `PhoneNumber`;
	static readonly Reference = `Reference`;
	static readonly Text = `Text`;
	static readonly Time = `Time`;
}
